module.exports = __webpack_public_path__ + "img/logs_search.2bfd0486.png";